import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _PERMISSION_RULES;

import { OrganizationRole, Product, ProductRole } from '../../graphql/__generated__/typeDefs'; // Continue exporting legacy type to support current implementations
// until everyone's switched over to using the graphql-gateway, but
// extend it to optionally allow all properties from ProductActivation

// Permissions must be a unique string and adhere to the following
// convention: resource:action
export var Permission;

(function (Permission) {
  Permission["LOG_USAGE_VISIT"] = "log-usage:visit";
  Permission["LOG_BILLING_VISIT"] = "log-billing:visit";
  Permission["AUDIT_TRAIL_VISIT"] = "audit-trail:visit";
  Permission["SECURITY_VISIT"] = "security:visit";
  Permission["TOKEN_VISIT"] = "token:visit";
  Permission["APPOPTICS_VISIT"] = "appoptics:visit";
  Permission["LOGGLY_VISIT"] = "loggly:visit";
  Permission["PINGDOM_VISIT"] = "pingdom:visit";
  Permission["LOG_CONFIGURATION_VISIT"] = "log-configuration:visit";
  Permission["APPOPTICS_BILLING_VISIT"] = "appoptics:billing-visit";
})(Permission || (Permission = {}));

var PERMISSION_RULES = (_PERMISSION_RULES = {}, _defineProperty(_PERMISSION_RULES, Permission.LOG_USAGE_VISIT, {
  products: [Product.Loggly]
}), _defineProperty(_PERMISSION_RULES, Permission.LOG_BILLING_VISIT, {
  products: [Product.Loggly],
  roles: [OrganizationRole.Owner]
}), _defineProperty(_PERMISSION_RULES, Permission.APPOPTICS_BILLING_VISIT, {
  productRoles: [{
    product: Product.Appoptics,
    roles: [ProductRole.Admin, ProductRole.Owner]
  }]
}), _defineProperty(_PERMISSION_RULES, Permission.AUDIT_TRAIL_VISIT, {
  roles: [OrganizationRole.Owner, OrganizationRole.Admin]
}), _defineProperty(_PERMISSION_RULES, Permission.SECURITY_VISIT, {
  roles: [OrganizationRole.Owner]
}), _defineProperty(_PERMISSION_RULES, Permission.APPOPTICS_VISIT, {
  products: [Product.Appoptics]
}), _defineProperty(_PERMISSION_RULES, Permission.LOGGLY_VISIT, {
  products: [Product.Loggly]
}), _defineProperty(_PERMISSION_RULES, Permission.PINGDOM_VISIT, {
  products: [Product.Pingdom]
}), _defineProperty(_PERMISSION_RULES, Permission.LOG_CONFIGURATION_VISIT, {
  roles: [OrganizationRole.Owner, OrganizationRole.Admin]
}), _defineProperty(_PERMISSION_RULES, Permission.TOKEN_VISIT, {
  roles: [OrganizationRole.Owner, OrganizationRole.Admin, OrganizationRole.Member]
}), _PERMISSION_RULES); // An array which MUST have at least one element.

var permissions = PERMISSION_RULES; // Evaluates the given role and enabled products list to determine whether the
// specified permission should be granted.

export function permissionGranted(permission, role, productAccess) {
  var _permissions$permissi = permissions[permission],
      roles = _permissions$permissi.roles,
      products = _permissions$permissi.products,
      productRoles = _permissions$permissi.productRoles;
  var roleRuleSatisfied = roles ? roles.includes(role) : true;
  var productRuleSatisfied = products ? hasProductActivated(products, productAccess) : true;
  var productRoleRuleSatisfied = productRoles ? hasProductRole(productRoles, productAccess) : true;
  return roleRuleSatisfied && productRuleSatisfied && productRoleRuleSatisfied;
}

function hasProductActivated(products, productAccess) {
  var enabledProducts = productAccess.filter(function (p) {
    return p.activated && p.productRole !== ProductRole.NoAccess;
  }).map(function (p) {
    return p.name;
  });
  return products.some(function (p) {
    return enabledProducts.includes(p);
  });
}

function hasProductRole(productRoles, productAccess) {
  return productRoles.some(function (pr) {
    return productAccess.some(function (pa) {
      return pa.productRole && pa.name === pr.product && pr.roles.includes(pa.productRole);
    });
  });
}